module.exports = __webpack_public_path__ + "img/MiddleSide_right.1aa9e4d8.png";